<template>
  <div class="page-step" :class="[$route.path.match(/gogatsu/) ? 'page-step-gogatsu' : '']">
    <transition name="animation-fade" mode="out-in">
      <router-view name="sidebar"/>
    </transition>

    <div
      class="page-step__body"
      :class="[!$route.meta.sidebar ? 'page-step__body--no-sidebar' : '']">
      <div class="page-step__body-inner">
        <transition :name="transitionSlide">
          <router-view :key="$route.params.order"/>
        </transition>
      </div>
      <v-step-nav :class="[!$route.meta.sidebar ? 'step-nav--no-sidebar' : '']"/>
    </div>

    <v-error-dialog/>
  </div>
</template>



<script>
import { mapState } from 'vuex'

export default {
  beforeRouteEnter (to, from, next) {
    next(vm => {
      let apiURL
      if (vm.config.debug) {
        apiURL = '/index_dev.php'
      } else {
        apiURL = '';
      }

      if (to.path.match(/gogatsu/)) {
        apiURL += '/api/choice/step?type=2&order='
      } else {
        apiURL += '/api/choice/step?type=1&order='
      }

      let order = vm.$route.params.order
      axios.get(apiURL + order, {
          params: vm.$route.query
        })
        .then(response => {
          vm.stepSet(response.data)
          vm.itemListSet(response.data.itemGroup.itemList, response.data.imagePositionList)

          if (response.data.selectedItems.length) vm.selectedItems(response.data.selectedItems)
          if (response.data.nextPage === null) vm.gaItemSet(response.data.selectedItems)

          window.scrollTo(0, 0)
        })
        .catch((error) => {
          let payload = {
            status: error.response.status,
            code: vm.config.errorCode.beforeRouteEnter + '' + error.response.status,
            message: 'エラーが発生しました。',
          }
          vm.$store.commit('error/errorSet', payload)
        })
    })
  },
  beforeRouteUpdate (to, from, next) {
    if (String(to.params.order) === String(from.params.order) || this.pageLoading) return next()

    const toPath = Number(to.params.order.replace('-', '.'))
    const fromPath = Number(from.params.order.replace('-', '.'))
    let apiURL
    this.pageLoading = true

    if (this.config.debug) {
      apiURL = '/index_dev.php'
    } else {
      apiURL = '';
    }

    if (to.path.match(/gogatsu/)) {
      apiURL += '/api/choice/step?type=2&order='
    } else {
      apiURL += '/api/choice/step?type=1&order='
    }

    if (toPath > fromPath) {
      this.transitionSlide = 'animation-slide-left'
    } else if (toPath < fromPath) {
      this.transitionSlide = 'animation-slide-right'
    }

    if (to.params.order !== from.params.order) {
      let order = to.params.order
      axios.get(apiURL + order, {
          params: to.query
        })
        .then(response => {
          console.log('response')
          console.log(response.data)

          let query = Object.assign({}, to.query)

          if (response.data.prevPage) {
            query.prevPageOrder = response.data.prevPage.order
            query.prevPageSlug = response.data.prevPage.slug
          }

          if (response.data.prevPage) {
            next({
              path: to.fullPath,
              query: query
            })
            if (this.browserBackFlag) {
              this.browserBackFlag = false
              location.reload()
            }
          } else {
            this.$store.commit('canvas/itemsReset')
            this.$store.commit('cart/itemsReset')

            if (from.query.preview) {
              next({
                path: to.path,
                query: {
                  preview: from.query.preview
                }
              })
              if (this.browserBackFlag) {
                this.browserBackFlag = false
                location.reload()
              }
            } else {
              next({
                path: to.path,
                query: null
              })
              if (this.browserBackFlag) {
                this.browserBackFlag = false
                location.reload()
              }
            }
          }

          this.stepSet(response.data)
          this.pageLoading = false
          this.itemListSet(response.data.itemGroup.itemList, response.data.imagePositionList)
          this.pageLoadedQuerySet()
          if (response.data.nextPage === null) this.gaItemSet(response.data.selectedItems)

          let array = ['1', '2', '3']
          if (!array.includes(String(to.params.order)) && !Object.keys(this.stateCartItems).length) {
            this.selectedItems(response.data.selectedItems)
          }

          let order = to.path.split('/')
          if (order[4] === 'complete') {
            this.$store.commit('step/selectItemSet', null)
          }

          this.$store.commit('page/loading', false)
          window.scrollTo(0, 0)
        })
        .catch((error) => {
          let payload = {
            status: error.response.status,
            code: this.config.errorCode.beforeRouteUpdate + '' + error.response.status,
            message: 'エラーが発生しました。',
          }
          this.$store.commit('error/errorSet', payload)
        })
        .finally(() => {
          return
        })
    }
  },
  components: {
    'v-step-nav': require('@/components/step-nav.vue').default,
    'v-error-dialog': require('@/components/error-dialog.vue').default,
  },
  data() {
    return {
      pageLoading: false,
      show: false,
      items: [],
      transitionSlide: 'animation-slide-left',
      browserBackFlag: false,
    }
  },
  computed: {
    ...mapState({
      stateItems: state => state.step.items,
      stateCurrent: state => state.step.current,
      stateCartItems: state => state.cart.items,
      authority: state => state.page.authority,
    })
  },
  mounted() {
    window.addEventListener('popstate', e => {
      this.browserBackFlag = true
    })
  },
  destroyed() {
    window.removeEventListener('popstate', e => {})
  },
  methods: {
    stepSet(data) {
      let step = {}
      step.prev = data.prevPage
      step.current = data.currentPage
      step.current.required = data.itemGroup.required
      step.showNameplate = data.showNameplate ? true : false

      this.$store.commit('step/stepSet', step)
    },
    itemListSet(data, position) {
      let list = []

      for (let i=0; i<data.length; i++) {
        list[i] = {}
        list[i].id = data[i].id
        list[i].name = data[i].name
        list[i].refine = true
        let imagePosition = this.imagePosition(data[i], position)

        if (i === data.length - 1){
          this.itemsSet(data[i].items, list[i], imagePosition, true)
        } else {
          this.itemsSet(data[i].items, list[i], imagePosition, false)
        }
      }

      this.$store.commit('step/listSet', list)
    },
    itemsSet(data, list, position, last) {
      let item = []
      let page = {}
      let select = false
      let query = Object.assign({}, this.$route.query)
      let query_item = query['order_' + this.$route.params.order]
      page.slug = this.stateCurrent.slug
      page.order = this.stateCurrent.order

      for (let i=0; i<data.length; i++) {
        item[i] = data[i]
        item[i].list = list
        item[i].page = page
        let setPosition = []

        if (item[i].preview_image) {
          for (var j=0; j<item[i].preview_image.length; j++) {
            for (var k=0; k<position.length; k++) {
              if (item[i].preview_image[j].id === position[k].preview_image_id) {
                setPosition.push(position[k])
              }
            }
          }
          item[i].position = setPosition
        }

        this.items.push(item[i])

        if (item[i].id + '' === query_item + '') {
          select = true
        }
      }

      if (last) {
        this.$store.commit('step/itemSet', this.items)
        this.items = []

        if (!select) {
          this.$store.commit('step/selectItemSet', null)
        }
      }
    },
    imagePosition(list, position) {
      let list_id = list.id

      if (position) {
        for (let i=0; i<position.length; i++) {
          let position_id = position[i].itemList_id

          if (list_id === position_id) {
            return position[i].imagePosition
          }
        }
      } else {
        return null
      }
    },
    pageLoadedQuerySet() {
      if (this.stateCurrent && !this.stateCurrent.required && !this.$route.query['order_' + this.$route.params.order]) {
        let query = Object.assign({}, this.$route.query)

        if (!this.$route.query['order_' + this.$route.params.order]) {
          query['order_' + this.$route.params.order] = 'null'
          this.$router.replace({ query: query })
        }
      }
    },
    selectedItems(data) {
      let step = []
      let cart = []
      let canvas = []
      let items = {}
      let listName = ''
      let noCanvasSlug = ['sizes', 'peoples']
      let root = this.$route.path.match(/gogatsu/) ?  "gogatsu" : "hina";
  

      for (let i = 0; i < data.length; i++) {
          if (root = "gogatsu"){
              if (Object.keys(data[i].label).length !== 0) {
                  listName = data[i].label
              } else if (data[i].page.slug === 'sizes') {
                  listName = 'カテゴリー'
              } else if (data[i].page.slug === 'peoples') {
                  listName = 'お人形の種類'
              }

          } else {
              if (Object.keys(data[i].label).length !== 0) {
                  listName = data[i].label
              } else if (data[i].page.slug === 'sizes') {
                  listName = 'サイズ'
              } else if (data[i].page.slug === 'peoples') {
                  listName = '人数'
              }
          }

        let item = {
          description: data[i].description,
          id: data[i].order_id,
          list: {
            name: listName,
          },
          name: data[i].name,
          page: data[i].page,
          thumbnail: data[i].thumbnail,
          position: data[i].imagePosition,
          preview_image: data[i].preview_image ? data[i].preview_image : null,
          price: data[i].price ? data[i].price : null,
          priceIncTax: data[i].priceIncTax ? data[i].priceIncTax : null,
          soldout: data[i].soldout ? data[i].soldout : null,
        }

        cart.push(item)
        if (data[i].preview_image) canvas.push(item)
      }
      this.$store.commit('cart/itemsFirstSet', cart)
      this.$store.commit('canvas/itemsFirstSet', canvas)
    },
    gaItemSet(data) {
      for (let i = 0; i < data.length; i++) {
        this.$ga.ecommerce.addProduct({
          id: data[i].order_id,
          name: data[i].name,
          price: data[i].price,
          quantity: 1,
        })
      }
      this.$ga.ecommerce.setAction('add')
    },
  }
}
</script>



<style lang="scss">
.page-step {
  $e: &;
  height: 100%;
  padding-top: 42px;
  &__body {
    @include breakpoints-min(md) {
      display: flex;
      justify-content: center;
      transition: $transition;
      position: relative;
      z-index: map-get($z-index, step-body);
      height: 100%;
    }
    @include breakpoints-min(lg) {
      margin-left: calc(#{$sidebar-width} - #{$sidebar-radius-width});
      padding-left: $sidebar-radius-width;
      &--no-sidebar {
        margin-left: 0;
        padding-left: 0;
        #{$e}__body-inner {
          width: $col-width * 3;
        }
      }
    }
  }
  &__body-inner {
    @include breakpoints-min(md) {
      position: relative;
      width: $col-width * 2;
      height: 100%;
    }
  }
  .sidebar {
  }
  .step-nav {
    @include breakpoints-min(lg) {
      transition: $transition;
      position: fixed;
      bottom: 0;
      left: 0;
      z-index: map-get($z-index, step-nav);
      width: 100%;
      padding-left: calc(#{$sidebar-width});
      &--no-sidebar {
        padding-left: 0;
      }
    }
  }
}

.page-step-gogatsu {

}
</style>
